import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/cost-calculator/CostCalculatorPage.tsx");
